<script lang="ts" setup>
import { useClassroomPip } from '@hooks/classroom/pip.hook'
import { useDesktopViewport } from '@hooks/classroom/desktop-viewport.hook'

import LessonRoomControlButton from '@Atoms/LessonRoom/LessonRoomControlButton.vue'

defineOptions({
  name: 'ButtonPip',
})

const {
  isSupported,
  isActive,
  toggle,
} = useClassroomPip()

const isDesktopViewport = useDesktopViewport()

const handleClick = (): void => {
  void toggle()
}
</script>

<template>
  <LessonRoomControlButton
    v-if="isSupported && isDesktopViewport"
    :icon="{ name: 'clone' }"
    label="Pic-in-pic"
    :enabled="isActive"
    @click="handleClick"
  />
</template>
